/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".text-cell[_ngcontent-%COMP%]{text-align:center;padding-top:7px}.ready-to-submit[_ngcontent-%COMP%]{background-color:#fff;color:#007f00;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);margin:5px 3px 2px;padding:4px 1px 3px 4px;border-radius:2px}.ready-to-submit[_ngcontent-%COMP%]:hover{background-color:#6168fd;font-weight:700;cursor:pointer}.ready-to-submit[_ngcontent-%COMP%]:hover   span[_ngcontent-%COMP%]{color:#fff}"];
export { styles as styles };
